import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, Observable, delay, map } from 'rxjs';
import { Announcement } from '../models/announcement.model';
import { ListingFilter } from '../models/home.model';
import { MOCK_ANNOUNCEMENTS } from '../models/mock-data';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ListingService {
  private readonly apiUrl = `${environment.apiUrl}/Listings`;

  constructor(private http: HttpClient) {}

  getVipListings(page: number, pageSize: number): Observable<Announcement[]> {
    const vips = MOCK_ANNOUNCEMENTS.filter(a => a.isVip);
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    return of(vips.slice(start, end)).pipe(delay(500));
  }

  getAllListings(filters: ListingFilter, page: number, pageSize: number): Observable<Announcement[]> {
    let params: any = {
      page: page.toString(),
      pageSize: pageSize.toString()
    };

    if (filters.dealType) params.dealType = filters.dealType === 'sale' ? '1' : '2';
    if (filters.propertyType) params.propertyType = filters.propertyType;
    if (filters.minPrice) params.minPrice = filters.minPrice.toString();
    if (filters.maxPrice) params.maxPrice = filters.maxPrice.toString();
    if (filters.cityId) params.administrativeArea = filters.cityId.toString();
    if (filters.districtId) params.subAreaId = filters.districtId.toString();
    if (filters.settlementId) params.settlementId = filters.settlementId.toString();
    if (filters.metroId) params.metroId = filters.metroId.toString();

    if (filters.rooms && filters.rooms.length > 0) {
      params.roomCount = filters.rooms.join(',');
    }

    return this.http.get<{ success: boolean, data: any[], error: any }>(`${this.apiUrl}/public`, { params })
      .pipe(
        map(res => {
          if (res.success && res.data) {
            return res.data.map(item => ({
              ...item,
              imageUrls: item.previewImageUrl ? [item.previewImageUrl] : (item.imageUrls || [])
            }));
          }
          return [];
        })
      );
  }

  createListing(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, data);
  }

  createGuestListing(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/guest`, data);
  }
}
